import {isFeatureEnabled} from '@github-ui/feature-flags'
import {
  AssigneePicker as AssigneePickerFuture,
  type AssigneePickerAssignee,
  type AssigneePickerSharedAssigneeKey,
  AssigneeRepositoryPicker as AssigneeRepositoryPickerFuture,
  BulkIssuesAssigneePicker as BulkIssuesAssigneePickerFuture,
  fetchSearchAssignees as fetchSearchAssigneesLegacyFuture,
  readAssigneeFromFragment as readAssigneeFromFragmentFuture,
} from '@github-ui/item-picker-assignee-relay'
import type {Environment} from 'react-relay'

import type {AssigneePickerAssignee$key} from './__generated__/AssigneePickerAssignee.graphql'
import type {RepositorySuggestedActorFilter} from './__generated__/AssigneePickerSearchAssignableRepositoryUsersQuery.graphql'
import {
  type AssigneeIssuePickerProps,
  AssigneePicker as AssigneePickerLegacy,
  AssigneeRepositoryPicker as AssigneeRepositoryPickerLegacy,
  type AssigneeRepositoryPickerProps,
  type BulkAssigneePickerProps,
  BulkIssuesAssigneePicker as BulkIssuesAssigneePickerLegacy,
  fetchSearchAssignees as fetchSearchAssigneesLegacy,
  readAssigneeFromFragment as readAssigneeFromFragmentLegacy,
} from './AssigneePicker'

// eslint-disable-next-line no-barrel-files/no-barrel-files
export {
  // eslint-disable-next-line no-barrel-files/no-barrel-files
  type AssigneeRepositoryPickerProps,
  SearchAssignableRepositoryUsers,
  SearchAssignableUsersQuery,
} from './AssigneePicker'

export function AssigneePicker(props: AssigneeIssuePickerProps) {
  const ffEnabled = isFeatureEnabled('item_picker_assignee_relay_migration')
  return ffEnabled ? <AssigneePickerFuture {...props} /> : <AssigneePickerLegacy {...props} />
}

export function AssigneeRepositoryPicker(props: AssigneeRepositoryPickerProps) {
  const ffEnabled = isFeatureEnabled('item_picker_assignee_relay_migration')
  return ffEnabled ? <AssigneeRepositoryPickerFuture {...props} /> : <AssigneeRepositoryPickerLegacy {...props} />
}

export function BulkIssuesAssigneePicker(props: BulkAssigneePickerProps) {
  const ffEnabled = isFeatureEnabled('item_picker_assignee_relay_migration')
  return ffEnabled ? <BulkIssuesAssigneePickerFuture {...props} /> : <BulkIssuesAssigneePickerLegacy {...props} />
}

export function readAssigneeFromFragment(
  key: AssigneePickerAssignee$key | AssigneePickerSharedAssigneeKey,
): AssigneePickerAssignee {
  const ffEnabled = isFeatureEnabled('item_picker_assignee_relay_migration')
  return ffEnabled
    ? readAssigneeFromFragmentFuture(key as AssigneePickerSharedAssigneeKey)
    : readAssigneeFromFragmentLegacy(key as AssigneePickerAssignee$key)
}

export function fetchSearchAssignees(
  environment: Environment,
  options: {
    owner: string
    repo: string
    assignees: string[]
    capabilities: RepositorySuggestedActorFilter[]
  },
) {
  const ffEnabled = isFeatureEnabled('item_picker_assignee_relay_migration')
  return ffEnabled
    ? fetchSearchAssigneesLegacyFuture(environment, options)
    : fetchSearchAssigneesLegacy(environment, options)
}

try{ AssigneePicker.displayName ||= 'AssigneePicker' } catch {}
try{ AssigneeRepositoryPicker.displayName ||= 'AssigneeRepositoryPicker' } catch {}
try{ BulkIssuesAssigneePicker.displayName ||= 'BulkIssuesAssigneePicker' } catch {}